import React from 'react';

import translationsStore from '../../../../../stores/translationsStore';

export default (
  <span>
    <div>{translationsStore.translate('lead.table.column.lastComm.last')}</div>
    <div>{translationsStore.translate('lead.table.column.lastComm.comm')}</div>
  </span>
);
